"use client";

import { c as _c } from "react/compiler-runtime";
import NFTImageBalance from "@/components/nft-image/NFTImageBalance";
import CollectionCardMetadataBadge from "./CollectionCardMetadataBadge";
interface OwnershipProps {
  readonly contract: string;
  readonly tokenId: number;
  readonly show: boolean;
}
interface Props {
  readonly tokenId: number | string;
  readonly mediaMimeType?: string | null | undefined;
  readonly mediaBadgeId?: string | undefined;
  readonly ownership?: OwnershipProps | undefined;
  readonly align?: "split" | "center" | undefined;
  readonly className?: string | undefined;
}
export default function CollectionCardMetadataRow(t0) {
  const $ = _c(15);
  const {
    tokenId,
    mediaMimeType,
    mediaBadgeId,
    ownership,
    align: t1,
    className: t2
  } = t0;
  const align = t1 === undefined ? "split" : t1;
  const className = t2 === undefined ? "" : t2;
  const rowClassName = align === "center" ? "tw-mt-3 tw-flex tw-w-full tw-min-w-0 tw-flex-wrap tw-items-center tw-justify-center tw-gap-x-2 tw-gap-y-1" : "tw-mt-3 tw-flex tw-w-full tw-min-w-0 tw-items-center tw-justify-between tw-gap-x-2 tw-gap-y-1";
  const metadataClassName = align === "center" ? "tw-flex tw-min-w-0 tw-items-center tw-justify-center" : "tw-ml-auto tw-flex tw-min-w-0 tw-items-center tw-justify-end";
  const t3 = `${rowClassName} ${className}`;
  let t4;
  if ($[0] !== t3) {
    t4 = t3.trim();
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== ownership) {
    t5 = ownership?.show && <div className="tw-flex tw-shrink-0 tw-items-center"><NFTImageBalance contract={ownership.contract} tokenId={ownership.tokenId} height={300} size="sm" variant="compact" /></div>;
    $[2] = ownership;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== mediaBadgeId || $[5] !== mediaMimeType || $[6] !== tokenId) {
    t6 = <CollectionCardMetadataBadge tokenId={tokenId} mediaMimeType={mediaMimeType} mediaBadgeId={mediaBadgeId} />;
    $[4] = mediaBadgeId;
    $[5] = mediaMimeType;
    $[6] = tokenId;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== metadataClassName || $[9] !== t6) {
    t7 = <div className={metadataClassName}>{t6}</div>;
    $[8] = metadataClassName;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t7) {
    t8 = <div className={t4}>{t5}{t7}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}